import { connect } from 'react-redux';
import {
  jira as jiraActions,
  modal as modalActions
} from '../actions';

import JiraConfirmModalComponent from '../Components/JiraConfirmModalComponent.jsx';
import { owners } from '../helpers/modals';
import {
  getCcfNcfBuildPageOrder,
  getModalInfoByOwner,
  getModalVisibility,
  getRelativeMetricsByScanKeys,
  getShowSources
} from './../reducers';

export const mapStateToProps = (state) => {
  const showSources = getShowSources(state);
  const modalInfo = getModalInfoByOwner(state, owners.jiraConfirm);
  const visible = getModalVisibility(state, owners.jiraConfirm);
  const props = {
    ...modalInfo,
    ccfNcfBuildOrder: getCcfNcfBuildPageOrder(state),
    metrics: getRelativeMetricsByScanKeys(state, modalInfo.scanKeys),
    visible,
    showSources
  };
  return props;
};

export default connect(
  mapStateToProps,
  {
    onHide: () => modalActions.showJiraConfirmModal(false, [], {}),
    setIssue: modalActions.setJiraConfirmDialogIssue,
    onConfirm: jiraActions.confirmJiraDialog,
    onTypesCheckChange: modalActions.setJiraConfirmCheckedTypes
  }
)(JiraConfirmModalComponent);


// WEBPACK FOOTER //
// src/Containers/JiraConfirmModalContainer.jsx